module.exports = __webpack_public_path__ + "static/img/looking-ahead-integrated-approach-hero-lores.d1f314c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/looking-ahead/looking-ahead-integrated-approach-hero-lores.jpg
// module id = bjd5
// module chunks = 0